LocalBookingWrapper = window.LocalBookingWrapper ?= {}

LocalBookingWrapper.init = ({booker}, done) ->
  $ ->
    Booking.dealBookerInit(booker)
    done()


module.exports = LocalBookingWrapper
